export default {
  zh: {
    noenough: "您没有足够的硬币来玩老虎机",
    later: "稍后",
    exchange: "兑换",
    close: "关闭",
    yes: "确定",
    title: "金币兑换",
    desc: "点击提取按钮手动提取黄金"
  },
  en: {
    noenough: "You don't have enough coins to play slot",
    later: "Later",
    exchange: "Exchange",
    close: "Close",
    yes: "Confirm",
    title: "Gold Exchange",
    desc: "Click the extract button to manually extract gold"
  },
  ar: {
    noenough: "You don't have enough coins to play slot",
    later: "Later",
    exchange: "Exchange",
    close: "Close",
    yes: "Confirm",
    title: "Gold Exchange",
    desc: "Click the extract button to manually extract gold"
  },
  uz:{
    "noenough": "Slot o'ynash uchun yetarli tangalaringiz yo'q",
    "later": "Keyinroq",
    "exchange": "Almashtirish",
    "close": "Yopish",
    "yes": "Tasdiqlash",
    "title": "Oltin Almashinuvi",
    "desc": "Oltin olish uchun tugmani bosing"
},
    ru:{
    "noenough": "У вас недостаточно монет для игры на слотах",
    "later": "Позже",
    "exchange": "Обменять",
    "close": "Закрыть",
    "yes": "Подтвердить",
    "title": "Обмен золота",
    "desc": "Нажмите кнопку извлечения, чтобы вручную извлечь золото"
},
   fa:{
    "noenough": "شما سکه کافی برای بازی در اسلات ندارید",
    "later": "بعدا",
    "exchange": "تعویض",
    "close": "بستن",
    "yes": "تأیید",
    "title": "تعویض طلا",
    "desc": "برای استخراج دستی طلا دکمه استخراج را فشار دهید"
},
    pt:{
    "noenough": "Você não tem moedas suficientes para jogar no slot",
    "later": "Mais tarde",
    "exchange": "Trocar",
    "close": "Fechar",
    "yes": "Confirmar",
    "title": "Troca de Ouro",
    "desc": "Clique no botão de extração para extrair o ouro manualmente"
},
    id:{
    "noenough": "Anda tidak memiliki koin yang cukup untuk bermain slot",
    "later": "Nanti",
    "exchange": "Tukar",
    "close": "Tutup",
    "yes": "Konfirmasi",
    "title": "Pertukaran Emas",
    "desc": "Klik tombol ekstrak untuk mengekstrak emas secara manual"
}






}


// WEBPACK FOOTER //
// src/pages/app/slotruby/lang.js